import { cn } from "@faire/react/tools/cn";
import { tsv } from "@faire/slate/lib/tsv";
import * as React from "react";

import { SpinnerSize } from "./type";
import { getSpinnerSize, getSpinnerStrokeWidth } from "./utils";

type IProps = React.SVGProps<SVGSVGElement> & {
  color?: string;
  size?: SpinnerSize;
};

/**
 */
export const SpinnerBase: React.FC<IProps> = ({
  className,
  color,
  size: sizeProp,
  ...props
}) => {
  const size = getSpinnerSize(sizeProp);
  const strokeWidth = getSpinnerStrokeWidth(sizeProp);
  const circleVars = circleStyles.vars({ color });
  return (
    <svg
      className={cn("fs-spinner", className)}
      viewBox="25 25 50 50"
      height={size}
      width={size}
      {...props}
    >
      <circle
        className="fs-spinner__circle"
        cx="50"
        cy="50"
        fill="none"
        r="20"
        style={circleVars}
        strokeMiterlimit="10"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

const circleStyles = tsv({
  vars: {
    color: "fs-spinner-color",
  },
});
